module.exports = __webpack_public_path__ + "img/photo-17.8aecf7fa.webp";